import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import React from 'react';
import { TripRoutes } from '../../Config/routes';
import HTTPClient from '../../Utils/HTTPClient';
import Header from '../Includes/Header';

const Triptype = () => {
  const [typeField, setTypeField] = React.useState('');
  const [typeId, setTypeId] = React.useState('');
  const [color, setcolor] = React.useState('');
  const [openDialog, setOpenDialog] = React.useState(false);
  const [typeList, setTypeList] = React.useState([]);

  const handleTypeInput = (e) => {
    setTypeField(e.target.value);
  };
  const handleSubmitForm = () => {
    const param = { type: typeField, color: color, id: typeId };
    HTTPClient.post(TripRoutes.addTripType, param)
      .then(() => {
        getTypeList();
        handleClearForm();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getTypeList = () => {
    HTTPClient.get(TripRoutes.tripTypesList)
      .then((response) => {
        setTypeList(response.data.typeList);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete?')) {
      const param = { id: id };
      HTTPClient.post(TripRoutes.deleteTripType, param)
        .then((response) => {
          if (response.data.status == 'success') {
            getTypeList();
          } else {
            alert(response.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const handleEdit = (id) => {
    HTTPClient.get(TripRoutes.getTripType(id))
      .then((response) => {
        if (response.data.type) {
          setTypeField(response.data.type.type);
          setcolor(response.data.type.color);
          setTypeId(response.data.type.id);
          setOpenDialog(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleClearForm = () => {
    setTypeField('');
    setTypeId('');
    setOpenDialog(false);
  };
  React.useEffect(() => {
    getTypeList();
  }, []);
  return (
    <React.Fragment>
      <Header />
      {openDialog ? (
        <Dialog open={openDialog} onClose={handleClearForm}>
          <DialogActions disableSpacing={true}>
            <IconButton
              className="close-pos close-span"
              onClick={() => {
                handleClearForm(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
          <DialogContent>
            <h4 className={'sethead'}>{typeId ? 'Update' : 'Create'} Trip Type</h4>
            <div style={{ minWidth: 275 }}>
              <p>
                <TextField
                  id="outlined-basic"
                  fullWidth={true}
                  label="Trip Type"
                  variant="outlined"
                  value={typeField}
                  onChange={handleTypeInput}
                  type="text"
                />
              </p>

              <p>
                <TextField
                  id="outlined-basic"
                  fullWidth={true}
                  label="Trip Type color"
                  variant="outlined"
                  value={color}
                  onChange={(e) => setcolor(e.target.value)}
                  type="color"
                />
              </p>
              <Button disabled={color.length == 0} onClick={handleSubmitForm} variant="contained">
                {typeId ? 'Update' : 'Create'}
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      ) : null}
      <Container maxWidth="md" className="settings-container">
        <Grid container>
          <Grid item sm={8}>
            <h2 className={'filterhead'}>Trip Type List</h2>
          </Grid>
          <Grid item sm={4} style={{ textAlign: 'right' }}>
            <IconButton
              onClick={() => setOpenDialog(true)}
              style={{ color: '#1a588c' }}
              fontSize={'large'}
            >
              <AddBoxRoundedIcon />
            </IconButton>
          </Grid>
        </Grid>

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table" className={'sett-table'}>
            <TableHead>
              <TableRow>
                <TableCell padding={'none'}>Type</TableCell>
                <TableCell padding={'none'}>Color</TableCell>
                <TableCell align="right" padding={'none'}>
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {typeList.map((row) => (
                <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell padding={'none'}>{row.type}</TableCell>
                  <TableCell padding={'none'}>
                    <span
                      style={{
                        width: '30px',
                        display: 'inline-block',
                        height: '30px',
                        background: row.color,
                        border: 'border 1px solid #ccc',
                      }}
                    ></span>
                  </TableCell>
                  <TableCell padding={'none'} align="right">
                    <IconButton onClick={() => handleEdit(row.id)} aria-label="edit">
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => handleDelete(row.id)} aria-label="delete">
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </React.Fragment>
  );
};

export default Triptype;
